import { DEFAULT_END, DEFAULT_START, setDate, triggerDateChange } from "./datepicker";
import { travels } from "./source";

$('#resetBtn').on('click', function () {

    //reset filters

    $('.dropdown-menu input:checked').each(function () {
        $(this).trigger("click");
    });


    $('.datesPopup select').val('').trigger('change');
    $('.entriesPopup select').val('').trigger('change');
    $('.rangesPopup select').val('').trigger('change');


    //reset layers

    if ($('#switchCheckReverse').is(':checked')) {
        $('.minYear').val('1485')
        $('.maxYear').val('1548')
        $('#switchCheckReverse').trigger("click");

    }

    if (!travels.getVisible() == true)
        $('.toggle').trigger("click");

    //reset dates

    setDate(DEFAULT_START, DEFAULT_END)
    triggerDateChange(DEFAULT_START, DEFAULT_END)

    //reset checkboxes
    if (!$('#stage1').is(':checked')) {
        $('#stage1').trigger("click");
    }

    if (!$('#stage2').is(':checked')) {
        $('#stage2').trigger("click");
    }

    if (!$('#stage3').is(':checked')) {
        $('#stage3').trigger("click");
    }

});